import React, { Component, createRef } from 'react';
import KheThreadReportListTable from './components/KheThreadReportListTable';
import { kheThreadReportStore } from './stores/KheThreadReportStore';
import { userDetailStores } from '../UserManagement/stores/UserDetailStores';
import UserDetailModal from '../UserManagement/components/UserDetail/UserDetailModal';
import KheThreadReportFeedbackModal from './components/KheThreadReportFeedbackModal';

class KheThreadReportList extends Component {
    constructor(props) {
        super(props);
        this.kheThreadReportFeedbackModalRef = createRef();
    };

    onShowUserInfo = (userId) => {
        if (!userId) return;
        userDetailStores.setUserIdForLoadDetail(userId);
        userDetailStores.onChangeUserDetailModal(true);
    }

    onFeedbackIconPress = (userIdToSend) => {
        if (this.kheThreadReportFeedbackModalRef.current) {
            this.kheThreadReportFeedbackModalRef.current.settUserIdToSendFeedback(userIdToSend);
        }
    }

    render() {
        return (
            <div className="card">
                <div className="card-body">
                    <KheThreadReportListTable
                        onFeedbackIconPress={this.onFeedbackIconPress}
                        onShowUserInfo={this.onShowUserInfo}
                    />
                </div>
                <UserDetailModal />
                <KheThreadReportFeedbackModal
                    ref={this.kheThreadReportFeedbackModalRef} />
            </div>
        );
    }

    componentDidMount = async () => {
        kheThreadReportStore.getData();
    };

}

export default KheThreadReportList;